import { render, staticRenderFns } from "./CancelAlertModal.vue?vue&type=template&id=13db24bc&scoped=true"
import script from "./CancelAlertModal.vue?vue&type=script&lang=ts"
export * from "./CancelAlertModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13db24bc",
  null
  
)

export default component.exports